import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserAuth } from '../context/UserAuthContext';

interface UseAdditionalInfoCheckProps {
  onNavigate: () => void; // 추가 정보가 필요하지 않거나 모달에서 확인했을 때 실행할 네비게이션 함수
}

export const useAdditionalInfoCheck = ({ onNavigate }: UseAdditionalInfoCheckProps) => {
  const navigate = useNavigate();
  const { user, isLoggedIn } = useUserAuth();
  const [showAdditionalInfoModal, setShowAdditionalInfoModal] = useState(false);

  const checkAndNavigate = () => {
    // 로그인되지 않은 경우는 다른 곳에서 처리
    if (!isLoggedIn) {
      onNavigate();
      return;
    }

    // 추가 정보가 필요한 경우 모달 표시
    if (user?.needMoreInfo) {
      setShowAdditionalInfoModal(true);
      return;
    }

    // 추가 정보가 필요하지 않은 경우 바로 네비게이션
    onNavigate();
  };

  const handleCloseModal = () => {
    setShowAdditionalInfoModal(false);
  };

  const handleGoToAdditionalInfo = () => {
    setShowAdditionalInfoModal(false);
    navigate('/additional-info');
  };

  return {
    showAdditionalInfoModal,
    checkAndNavigate,
    handleCloseModal,
    handleGoToAdditionalInfo,
  };
};
